import React from 'react';
import './RatingInput.sass';

import {injectIntl} from 'react-intl';

const STAR_PATH = 'M6.71468 0.878114C6.80449 0.601721 7.19551 0.601722 7.28532 0.878115L8.72876 5.32057C8.76892 5.44418 8.88411 5.52786 9.01408 5.52786H13.6851C13.9758 5.52786 14.0966 5.89975 13.8615 6.07057L10.0825 8.81616C9.97736 8.89255 9.93336 9.02796 9.97352 9.15157L11.417 13.594C11.5068 13.8704 11.1904 14.1003 10.9553 13.9294L7.17634 11.1838C7.07119 11.1074 6.92881 11.1075 6.82366 11.1838L3.04469 13.9294C2.80957 14.1003 2.49323 13.8704 2.58303 13.594L4.02648 9.15157C4.06664 9.02796 4.02264 8.89255 3.91749 8.81616L0.138516 6.07057C-0.0965979 5.89975 0.0242358 5.52786 0.314853 5.52786H4.98593C5.11589 5.52786 5.23108 5.44418 5.27124 5.32057L6.71468 0.878114Z';

const FILLED = '#f1be44';
const EMPTY = 'rgba(255, 255, 255, 0.25)';

// Interactive 5-star picker with hover preview and a live rating word.
// Controlled by `value` (1–5, 0 = unset); calls `onChange` with the clicked
// rating. The hovered star (and everything left of it) previews gold; on
// mouse-leave the selected value is restored.
@injectIntl
export default class RatingInput extends React.PureComponent {
  state = {hover: 0};

  render() {
    const {intl, value = 0, onChange} = this.props;
    const {hover} = this.state;

    const shown = hover || value;
    // Persistent "Tap to rate" hint before any pick; the live rating word after.
    const word = shown
      ? intl.formatMessage({id: `page.review.rating.${shown}`})
      : intl.formatMessage({id: 'page.review.tap-to-rate'});

    return (
      <div className="rating-input">
        <div
          className="rating-input__stars"
          onMouseLeave={() => this.setState({hover: 0})}
        >
          {[1, 2, 3, 4, 5].map((i) => (
            <button
              key={i}
              type="button"
              className="rating-input__star"
              aria-label={intl.formatMessage({id: `page.review.rating.${i}`})}
              onClick={() => onChange(i)}
              onMouseEnter={() => this.setState({hover: i})}
            >
              <svg width="30" height="30" viewBox="0 0 14 14" fill="none">
                <path d={STAR_PATH} fill={i <= shown ? FILLED : EMPTY}/>
              </svg>
            </button>
          ))}
        </div>

        <span className="rating-input__word">{word}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/reviews/RatingInput.js